import { debug } from "console";

//turn on - off on loggers
const errorlogger = true;
const debuglogger = true;

export const ErrorLogger = (message: string, alertMode: boolean = false) => {
    if (errorlogger) {
        if (!alertMode)
            console.log('Error: ' + message);
        else
            alert('Error: ' + message);
    }
}
export const DebugLogger = (message: string, alertMode: boolean = false) => {
    if (debuglogger) {
        if (!alertMode)
            console.log('Debug: ' + message);
        else
            alert('Debug: ' + message);
    }
}